import * as React from "react"
import { Link } from "gatsby"
import {
  container,
  message,
  learnMoreLink,
  consentLink
} from "./cookie-consent.module.css"
import { useCookies } from 'react-cookie'

export function CookieConsent() {

  const [cookies, setCookie] = useCookies(['cookieconsent']);
  const [isVisible, setisVisible] = React.useState(false);

  const consent = () => {
    setisVisible(false)
    let yearFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    setCookie("cookieconsent", "true", { expires: yearFromNow })
  }

  React.useEffect(() => {
    setisVisible(!cookies.cookieconsent)
  }, [cookies])

  return (
    isVisible && <div className={container}>
      <span className={message}>
        This website uses cookies to ensure you get the best experience on our website.
        <Link to="/policies/privacy-policy/" className={learnMoreLink}>Learn More</Link>
      </span>
      <div>
        <span className={consentLink} onClick={consent} onKeyDown={consent} tabIndex="0" role="button">OK</span>
      </div>
    </div>
  )
}
